export const noStockMessage =
  'Sin stock para esta cantidad. Pedido pendiente hasta que la sucursal consulte la disponibilidad de este producto.'

export const productWithCotizacionInDollars =
  'Producto comercializado en dólares (Referencia: BNA oficial venta). El tipo de cambio se fija en el momento de la aprobación del pedido.'
export const pricesUpdatedMessage =
  'Actualizamos algunos precios de los articulos elegidos'
